import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { InputViewModel } from '@sitecore-jss/sitecore-jss-forms';
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms';
import { NextRouter, withRouter } from 'next/router';

import { DEFAULT_CHINA_LOCALE } from '@gn-audio/jss-core/common/constants';

import { useGoogleRecaptchaManager } from '../../../contexts/GoogleRecaptchaManagerContext';
import ChineseRecaptchaStubInput from './ChineseRecaptchaStubInput';
import GoogleRecaptchaV3Input from './GoogleRecaptchaV3Input';

const GoogleRecaptchaV3: React.FC<
  ValueFieldProps<InputViewModel> & { router: NextRouter; googleRecaptchaV3SiteKey: string }
> = ({ router, ...props }) => {
  const { googleRecaptchaV3SiteKey } = useGoogleRecaptchaManager();

  const isChineseLocale = router.locale?.toLowerCase() === DEFAULT_CHINA_LOCALE.toLowerCase();

  // Google services are not available in China, so we need to use a stub input instead to bypass the reCAPTCHA validation.
  if (isChineseLocale) {
    return <ChineseRecaptchaStubInput router={router} {...props} />;
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={googleRecaptchaV3SiteKey}
      scriptProps={{
        async: true,
        defer: true,
      }}
      useRecaptchaNet
    >
      <GoogleRecaptchaV3Input {...props} />
    </GoogleReCaptchaProvider>
  );
};

export default withRouter(GoogleRecaptchaV3);
